export enum Country {
  Sweden = 'se',
  Slovakia = 'sk',
  Czechia = 'cz',
  Hungary = 'hu',
  WesternEurope = 'we',
  Norway = 'no',
  Serbia = 'rs'
}
